import { gql } from "@apollo/client";

const PROGRAM_FRAGMENT = gql`
  fragment ProgramFragment on AdminProgram {
    slug
    title
    level
    style
    categories
    instructorSlug
    instructorName
    isFree
    hidden
    publishDate
    averageSessionTime
    totalClassesCount
    content
    blocks
    sections
    classes
    relatedClasses
  }
`;

export const GET_LIST_PROGRAMS = gql`
  ${PROGRAM_FRAGMENT}
  query AllPrograms {
    adminProgramGetList {
      ...ProgramFragment
    }
  }
`;

export const GET_ONE_PROGRAM = gql`
  ${PROGRAM_FRAGMENT}
  query ProgramBySlug($slug: String!) {
    adminProgramGetOne(slug: $slug) {
      ...ProgramFragment
    }
  }
`;

export const CREATE_PROGRAM = gql`
  ${PROGRAM_FRAGMENT}
  mutation CreateProgram($input: ProgramCreateInput!) {
    adminProgramCreate(input: $input) {
      ...ProgramFragment
    }
  }
`;

export const UPDATE_PROGRAM = gql`
  ${PROGRAM_FRAGMENT}
  mutation UpdateProgram($input: ProgramUpdateInput!) {
    adminProgramUpdate(input: $input) {
      ...ProgramFragment
    }
  }
`;

export const PUBLISH_PROGRAM = gql`
  ${PROGRAM_FRAGMENT}
  mutation PublishProgram($slug: String!) {
    adminProgramPublish(slug: $slug) {
      ...ProgramFragment
    }
  }
`;

export const UNPUBLISH_PROGRAM = gql`
  ${PROGRAM_FRAGMENT}
  mutation UnPublishProgram($slug: String!) {
    adminProgramUnPublish(slug: $slug) {
      ...ProgramFragment
    }
  }
`;

export const DELETE_PROGRAM = gql`
  mutation DeleteProgram($slug: String!) {
    adminProgramDelete(slug: $slug)
  }
`;
